import type { OptionObj } from "../interfaces/common";

export const WebsiteVertical = {
  STANDARD: 1,
  LUX: 2,
} as const;

export const WebsiteVerticalLabels = {
  STANDARD: "STANDARD",
  LUX: "LUXE",
} as const;

export type WebsiteVerticalLabelTypes = (typeof WebsiteVerticalLabels)[keyof typeof WebsiteVerticalLabels];

export type WebsiteVerticalTypes = (typeof WebsiteVertical)[keyof typeof WebsiteVertical];

export const WebsiteVerticalOptions: OptionObj<number>[] = [
  { label: WebsiteVerticalLabels.STANDARD, value: WebsiteVertical.STANDARD },
  { label: WebsiteVerticalLabels.LUX, value: WebsiteVertical.LUX },
];

export const ContentVertical = {
  ALL: 0,
  STANDARD: 1,
  LUX: 2,
} as const;

export type ContentVerticalTypes = (typeof ContentVertical)[keyof typeof ContentVertical];

export const ContentVerticalOptions: OptionObj<number>[] = [
  { label: "ALL", value: ContentVertical.ALL },
  { label: "STANDARD", value: ContentVertical.STANDARD },
  { label: "LUXE", value: ContentVertical.LUX },
];

export const WEBSITE_TYPE_SWITCH_OPTIONS = [
  {
    label: WebsiteVerticalLabels.STANDARD,
    value: WebsiteVerticalLabels.STANDARD,
    ariaLabel: "Standard Website",
  },
  {
    label: WebsiteVerticalLabels.LUX,
    value: WebsiteVerticalLabels.LUX,
    ariaLabel: "Luxe Website",
  },
];
